<template>
    <div id="Vue2Editor">
        <v-snackbar
            v-model="snackbar"
            :vertical="vertical"
            top
            >
            {{ feedback }}
            <v-btn color="primary" text @click="snackbar = false">
                Close
            </v-btn>
        </v-snackbar>
        <vue-editor
        id="editor"
        v-model="richContent"
        :editorToolbar="customToolbar"
        :editorOptions="editorSettings"
        useCustomImageHandler
        @image-added="handleImageAdded"
        ></vue-editor>
        <v-row justify="start" class="mt-3 pl-3">
            <v-btn small class="mr-4" @click="save2firestore">Save</v-btn>
        </v-row>
    </div>
</template>

<script>
/* eslint-disable no-console */
// import { VueEditor } from "vue2-editor";
import {storage, db, auth} from '@/fb';

import { VueEditor, Quill } from "vue2-editor";
// import BlotFormatter from 'quill-blot-formatter';
import BlotFormatter from 'quill-blot-formatter/dist/BlotFormatter';
import AlignAction from 'quill-blot-formatter/dist/actions/align/AlignAction';
import DeleteAction from 'quill-blot-formatter/dist/actions/DeleteAction';
import ImageSpec from 'quill-blot-formatter/dist/specs/ImageSpec';

Quill.register('modules/blotFormatter', BlotFormatter);

class CustomImageSpec extends ImageSpec {
    getActions() {
        return [AlignAction, DeleteAction];
    }
}

export default {
    name:'Vue2Editor',
    props:['editor','second_editor'],
    components: {
        VueEditor
    },
    data(){
        return{
            snackbar:false,
            vertical: true,
            feedback:null,

            richContent:"",

            customToolbar: [
                [{header: [false, 1, 2, 3, 4, 5, 6]}],
                ["bold", "italic", "underline"], 
                [{ list: "ordered" }, { list: "bullet" }], 
                ["image", "code-block"],
                [{indent: "-1"}, {indent: "+1"}],
                [{color: []}, {background: []}],
                ["link"], ["clean"],
            ],
            editorSettings: {
                modules: {
                    blotFormatter: {
                        spec:[
                            CustomImageSpec,
                        ],
                        overlay: {
                            style: {
                            border: '2px solid red',
                            }
                        }
                        // see config options below
                    }
                }
            } 
        }
    },
    computed:{
        computedEditor(){
            if(this.editor ==null){
                return ""
            }else{
                return this.editor
            }
        },
        computedSecondEditor(){
            if(this.second_editor ==null){
                return ""
            }else{
                return this.second_editor
            }
        }
    },
    created(){
        let ref = db.collection('reports')
            ref.doc(String(this.$route.params.id)).get()
            .then(doc=>{
                this.richContent = doc.data().report_comment
            })
            .catch(err=>{
                console.log("created error")
                console.log(err)
            })
    },
    methods:{
        handleImageAdded (file, Editor, cursorLocation, resetUploader) {
            // var self = this
            var fileEditor = file
            var storageRef = storage.ref();

            var user = auth.currentUser;

            //upload to firebase storage
            var uploadTask = storageRef.child('editor/'+user.email+'/'+Date.now()+'_'+fileEditor.name).put(fileEditor);
            uploadTask.on('state_changed', snapshot=>{
                var avatarProgress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                if(avatarProgress == 100){
                    this.feedback = "picture uploaded!"
                    setTimeout(()=>{
                        this.feedback = null;
                    },2000)
                }
            }, err=>{
                console.log(err)
            }, ()=>{
                uploadTask.snapshot.ref.getDownloadURL().then((downloadURL)=>{
                    let url = downloadURL
                    Editor.insertEmbed(cursorLocation, 'image', url);
                    resetUploader();
                });
            });
        },
        save2firestore(){
            let ref = db.collection('reports').doc(String(this.$route.params.id));
            ref.set({
                report_comment: this.richContent,
                editor: this.computedEditor,
                second_editor:this.computedSecondEditor,
            },{ merge: true })
            .then(()=>{
                this.feedback = "保存しました。"
                this.snackbar = true
            })
            .catch(err=>{
                this.feedback = "エラー：保存できませんでした。容量を1MB以下にしてください、またはインターネット接続を確認してください。"
                this.snackbar = true
                /* eslint-disable no-console */
                console.log(err)
                /* eslint-enable no-console */
            })
        },
    },
}
</script>

<style>
    #editor {
        height: 500px;
    }
</style>